/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ErrorNotificationComponent } from '../../notification-components/system-notifications/error-notification-component';
import { withNotificationComponent } from '../base';
import { SystemNotification } from './system-notification';

/**
 * Represents an error notification.
 * Use this notification when some flow fails and you want to display a simple message to the user.
 * This is one of the types of system notifications.
 */
@withNotificationComponent(ErrorNotificationComponent)
export class ErrorNotification extends SystemNotification { }